<template>
	<div class="editEmployerUser">
		<!-- Main Body Content area -->
	    <div class="o-main-content-area">
	        <!-- Heading Section -->
	        <div class="row c-responsive-fixwidth">
	            <div class="col-md-6">
	                <h1 class="h1">Add Employer User (Billed Monthly) :</h1>
	            </div>
	            <div class="col-md-6 text-right">
	                <ul class="o-filter-area">
	                    <li><a href="javascript: void(0)" @click="$router.go(-1)" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a></li>
	                    <li><a href="javascript: void(0)" @click="uploadService()" class="c-common-btn c-common-btn--large c-common-btn--green"><i class="fa fa-save"></i> Save</a></li>
	                </ul>

	            </div>
	        </div>
	        <!-- /Heading Section -->
	    </div>
	    <div v-loading="loading" class="o-ndividualArea c-responsive-fixwidth">
	        <div class="o-ndividualTable employer-info">
	            <div class="field-group">
	                <div class="row">
	                  <div class="col-sm-12">
	                    <div class="c-common-space c-responsive-fixwidth c-common-box-shadow c-radius3 c-user-tab-content clearfix o-skillset-area o-table-display">
	                      <div class="col-sm-3 o-table-cell-display">
	                        <div class="employerpic-upload-sec">
	                            <div class="employerpic-upload">
	                                <!-- <img src="static/assets/images/user1.png" alt="" id='img-upload'> -->
	                                <img
                                      :src="finalCropImg"
                                      alt="Cropped Image"
                                    />
	                            </div>
	                            <div class="employerpic-upload-btn o-upload-profile-btn">
                                 <div class="input-group">
                                     <span class="input-group-btn">
                                         <span class="btn btn-default btn-file">
                                             <input type="file" id="imgInp" @change="addProfileImg($event)">
                                         </span>
                                     </span>
                                     <input type="text" class="form-control" readonly>
                                 </div>
                                 <i class="fa fa-plus"></i>
                             	</div>
	                        </div>
	                      </div>
	                      <div class="col-sm-9 no_padding o-table-cell-display">
	                        <p>Basic Info:</p>
	                        <!-- <div class="row">
	                            <div class="col-sm-6">
	                                <div class="form-group ">
	                                    <label class="common-label-text">Company Name:<sup>*</sup></label>
	                                    <input v-model="employer.company_name" v-validate="'required'" name="company name" type="text" class="form-control" placeholder="Name">
	                                   <span class="err-msg">{{ errors.first('company name') }}</span>
	                                </div>
	                            </div>
	                            <div class="col-sm-6">
	                            	<div class="form-group ">
	                                    <label class="common-label-text">Company Email:<sup>*</sup></label>
	                                    <input v-model="employer.company_email" v-validate="'required|email'" name="company email" type="email" class="form-control" placeholder="Email">
	                                    <span class="err-msg">{{ errors.first('company email') }}</span>
	                                </div>
	                            </div>
	                        </div> -->
	                        <!-- <p>Admin User (Free):</p> -->
	                        <div class="row">
	                            <div class="col-sm-12">
	                                <div class="form-group ">
	                                    <label class="common-label-text">Contact Person Name:<sup>*</sup></label>
	                                    <input v-model="employer.name" v-validate="'required'" name="Contact Person" type="text" class="form-control" placeholder="Name">
	                                    <span class="err-msg">{{ errors.first('Contact Person') }}</span>
	                                </div>
	                            </div>
	                            <!-- <div class="col-sm-4">
	                                <div class="form-group ">
	                                    <label class="common-label-text">Nickname:</label>
	                                    <input v-model="employer.nick_name" name="nickname" type="text" class="form-control" placeholder="Nickname">
	                                </div>
	                            </div> -->
	                            <div class="col-sm-12">
	                                <div class="form-group ">
	                                    <label class="common-label-text">Email:<sup>*</sup></label>
	                                    <input @change="emailExists()" v-model="employer.email" v-validate="'required|email'" name="email" type="text" class="form-control" placeholder="Email">
	                                    <span class="err-msg">{{ errors.first('email') }}</span>
	                                    <span class="err-msg" v-if="!email_status && !(errors.has('email'))">Email already exists.</span>
	                                </div>
	                            </div>
	                            <!-- <div class="col-sm-4">
	                                <div class="form-group ">
	                                    <label class="common-label-text">Secondary Email:</label>
	                                    <input v-model="employer.secondary_email" v-validate="'email'" name="Secondary Email" type="email" class="form-control" placeholder="Email">
	                                    <span class="err-msg">{{ errors.first('Secondary Email') }}</span>
	                                </div>
	                            </div> -->
	                            <!-- <div class="col-sm-4">
	                                <div class="form-group ">
	                                    <label class="common-label-text">Password:<sup>*</sup></label>
	                                    <input v-model="employer.password" v-validate="{required: true, min: 6  }" name="password" type="password" class="form-control" placeholder="Password">
	                                    <span class="err-msg">{{ errors.first('password') }}</span>
	                                </div>
	                            </div>
	                            <div class="col-sm-4">
	                                <div class="form-group ">
	                                    <label class="common-label-text">Confirm Password:<sup>*</sup></label>
	                                    <input v-model="employer.confirmPassword" v-validate="{ is: employer.password, required: true}" type="password" name="confirm" class="form-control" placeholder="Password">
	                                    <span class="err-msg">{{ errors.first('confirm') }}</span>
	                                </div>
	                            </div> -->
	                        </div>
	                        <div class="row">
	                            
	                        </div>
	                      </div>
	                    </div>
	                  </div>
	                </div>
	            </div>
	            <!-- <div class="field-group">
	                <div class="row">
	                    <div class="col-sm-12">
	                        <h3>Contact Person</h3>
	                        <div class="c-common-space c-responsive-fixwidth c-common-box-bordered c-radius3">
	                            <div class="c-common-box-shadow c-radius3 c-user-tab-content clearfix o-skillset-area">
	                                <p>Admin User(Free):</p>
	                                <div class="row">
	                                    <div class="col-sm-3">
	                                        <div class="form-group ">
	                                            <label class="common-label-text">Contact Person Name:</label>
	                                            <input v-model="employer.cpName"type="text" class="form-control" placeholder="Name">
	                                        </div>
	                                    </div>
	                                    <div class="col-sm-3">
	                                        <div class="form-group ">
	                                            <label class="common-label-text">Email:</label>
	                                            <input v-model="employer.cpEmail"type="text" class="form-control" placeholder="Name">
	                                        </div>
	                                    </div>
	                                    <div class="col-sm-3">
	                                        <div class="form-group ">
	                                            <label class="common-label-text">Phone:</label>
	                                            <input v-model="employer.cpPhone" type="text" class="form-control" placeholder="Name">
	                                        </div>
	                                    </div>
	                                    <div class="col-sm-3">
	                                        <div class="form-group ">
	                                            <label class="common-label-text">Client Access:</label>
	                                            <input v-model="employer.cpClientAccess" type="text" class="form-control" placeholder="Name">
	                                        </div>
	                                    </div>
	                                </div>
	                            </div>
	                        </div>
	                    </div>
	                </div>
	            </div> -->
	            <div class="c-common-space c-responsive-fixwidth c-radius3">
	                <div class="c-common-box-shadow c-radius3 c-user-tab-content clearfix o-skillset-area">
	                  <div class="field-group">
	                      <div class="row">
	                          <div class="col-sm-12">
	                              <div class="c-common-space c-responsive-fixwidth">
	                                  <div class="clearfix o-skillset-area">
	                                      <p>Address:</p>
	                                      <div class="row">
	                                          <div class="col-sm-3">
	                                              <div class="form-group ">
	                                                  <label class="common-label-text">Street Address:</label>
	                                                  <input v-model="employer.address" type="text" class="form-control" placeholder="Street Address">
	                                              </div>
	                                          </div>
	                                          <div class="col-sm-3">
	                                              <div class="form-group ">
	                                                  <label class="common-label-text">City:</label>
	                                                  <input v-model="employer.municipality" type="text" class="form-control" placeholder="City">
	                                              </div>
	                                          </div>
	                                          <div class="col-sm-3">
	                                              <div class="form-group ">
	                                                  <label class="common-label-text">State:</label>
	                                                  <input v-model="employer.state_province" type="text" class="form-control" placeholder="State">
	                                              </div>
	                                          </div>
	                                          <div class="col-sm-3">
	                                              <div class="form-group ">
	                                                  <label class="common-label-text">Zip:</label>
	                                                  <input v-model="employer.postcode" type="text" class="form-control" placeholder="Zip">
	                                              </div>
	                                          </div>
	                                      </div>
	                                  </div>
	                              </div>
	                          </div>
	                      </div>
	                  </div>
	                  <div class="field-group">
	                      <div class="row">
	                          <div class="col-sm-12">

	                                  <div class="c-common-space c-responsive-fixwidth">
	                                      <div class="clearfix o-skillset-area">
	                                          <p>Phone & Fax:</p>
	                                          <div class="row">
	                                              <div class="col-sm-3">
	                                                  <div class="form-group ">
	                                                      <label class="common-label-text">Primary Phone:</label>
	                                                      <input v-model="employer.primary_phone" name="phone" type="tel" class="form-control" placeholder="Primary Phone Number">
	                                                      <!-- <span class="err-msg">{{ errors.first('phone') }}</span><sup>*</sup>v-validate="'required'"  -->
	                                                  </div>
	                                              </div>
	                                              <div class="col-sm-3">
	                                                  <div class="form-group ">
	                                                      <label class="common-label-text">Secondary Phone:</label>
	                                                      <input v-model="employer.secondary_phone" type="tel" class="form-control" placeholder="Secondary Phone Number">
	                                                  </div>
	                                              </div>
	                                              <div class="col-sm-3">
	                                                  <div class="form-group ">
	                                                      <label class="common-label-text">Cell Phone:</label>
	                                                      <input v-model="employer.cell_phone" type="tel" class="form-control" placeholder="Cell Phone Number">
	                                                  </div>
	                                              </div>
	                                              <div class="col-sm-3">
	                                                  <div class="form-group ">
	                                                      <label class="common-label-text">Fax:</label>
	                                                      <input v-model="employer.fax" type="number" class="form-control" placeholder="Fax">
	                                                  </div>
	                                              </div>
	                                          </div>
	                                      </div>
	                              </div>
	                          </div>
	                      </div>
	                  </div>
	                </div>
	              </div>
	        </div>
	        <!-- /Main Body Content area -->
	    </div>
	    <!-- /Main Content Area -->
	    <modal name="crop-image"  height="auto" :scrollable="true" class="modal-dialog modal-sm">
		    <div class="modal-add-newJob" tabindex="-1" role="dialog">
		        <div  role="document">
		            <div class="modal-content o-common-modal-content">
		                <div class="modal-header u-no-border text-center o-small-modal-head">
		                    <button @click="closeCropModal()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
		                    <h4 class="modal-title">Edit Image</h4>
		                </div>
		                <div class="modal-body c-common-box-shadow o-modal-nopad-body">
		                    <div class="row">
		                        <div class="col-sm-6">
		                             <div class="c-common-space c-radius3">
		                                 <div class="c-user-tab-content clearfix o-skillset-area">
		                                     <div class="layout-table">
		                                         <div class="layout-table-cell">
		                                             <div class="employerpic-upload-sec">
		                                                 <!-- <div class="employerpic-upload"> -->
		                                                     <!-- <vue-cropper
		                                                      ref="cropper"
		                                                      :src="cropableImgPath"
		                                                      alt="Source Image"
		                                                    >
		                                                    </vue-cropper> -->
		                                                 <!-- </div> -->
		                                                 <vue-cropper
		                                                    ref="cropper"
		                                                    :guides="true"
		                                                    :view-mode="0"
		                                                    drag-mode="crop"
		                                                    :auto-crop-area="0.5"
		                                                    :min-container-width="250"
		                                                    :min-container-height="180"
		                                                    :background="true"
		                                                    :rotatable="true"
		                                                    :src="cropableImg"
		                                                    alt="Source Image"
		                                                  >
		                                                </vue-cropper>

		                                                    <!-- :img-style="{ width: '400px', height: '300px' }" -->
		                                             </div>
		                                         </div>
		                                     </div>
		                                 </div>
		                             </div>
		                        </div>
		                        <div class="col-sm-6">
		                             <div class="c-common-space c-radius3">
		                                 <div class="c-user-tab-content clearfix o-skillset-area">
		                                     <div class="layout-table">
		                                         <div class="layout-table-cell">
		                                             <div class="employerpic-upload-sec">
		                                                <div>
		                                                    <a href="javascript: void(0)" @click="cropImage()" v-if="cropableImg != ''" data-dismiss="modal" aria-label="Close" class="btn c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-crop" aria-hidden="true"></i> Crop</a>

		                                                    <a href="javascript: void(0)" @click="rotate" v-if="cropableImg != ''" data-dismiss="modal" aria-label="Close" class="btn c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-repeat" aria-hidden="true"></i> Rotate</a>
		                                                </div>
		                                                <div class="crop-image-top-margin">
		                                                    <img
		                                                      v-if="cropImg && cropImg!=''"
		                                                      :src="cropImg"
		                                                      style="width: 200px; border: 1px solid gray"
		                                                      alt="Cropped Image"
		                                                    />
		                                                </div>
		                                                
		                                                
		                                             </div>
		                                         </div>
		                                     </div>
		                                 </div>
		                            </div>
		                        </div>
		                    </div>

		                </div>
		                <div class="modal-footer text-center">
		                    <ul class="o-filter-area">
		                        <li>
		                            <a href="javascript: void(0)" @click="completeEdit()" data-dismiss="modal" aria-label="Close" class="btn c-common-btn c-common-btn--large c-common-btn--green"><i class="fa fa-floppy-o" aria-hidden="true"></i> Done</a>
		                        </li>
		                        <li>
		                            <a href="javascript: void(0)" @click="closeCropModal()" data-dismiss="modal" aria-label="Close" class="btn c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
		                        </li>
		                        
		                    </ul>
		                </div>
		            </div>
		        </div>
		    </div>
		</modal>
	</div>
</template>
<script>
    import dateTimeConvert from '../../timeConvert&Compare';
    import {mapGetters, mapActions} from 'vuex';
    import service from '../../services.js';

    import VueCropper from 'vue-cropperjs';
    import 'cropperjs/dist/cropper.css';

    export default {
    	components: { 
            VueCropper
        },
        data() {
            return {
            	cropImg:'',
                cropableImg:'',
                finalCropImg:'static/assets/images/user1.png',
            	employer:{
            		image:'',
            		name:'',
            		nick_name:'',
            		email:'',
            		secondary_email:'',
            		password:'',
            		confirmPassword:'',

        			address:'',
        			municipality:'',
        			postcode:'',
        			state_province:'',

        			primary_phone:'',
        			secondary_phone:'',
        			cell_phone:'',
        			fax:'',     	
            	},
            	email_status:1,
            	image:[], 
            	loading:false,      
        		img_format:['jpg', 'jpeg', 'png', 'gif'],           
            }
        },
        computed: {
            ...mapGetters({

                userToken: 'userToken',
                companyId: 'companyId',
                // userRole: 'userRole',
                // userClientID: 'userClientID',
            })
        },
        methods: {
        	openCropModal(){
                this.$modal.show('crop-image');
            },
            closeCropModal(){
                this.$modal.hide('crop-image');
            },
            cropImage() {
              // get image data for post processing, e.g. upload or setting image src
              this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
            },
            rotate() {
              // guess what this does :)
              this.$refs.cropper.rotate(90);
            },
            completeEdit(){
                this.finalCropImg=this.cropImg;
                this.image[0].img=this.cropImg;
                this.$modal.hide('crop-image');
                $('#imgInp').val(null);
                console.log(this.image[0]);
            },
        	addEmployer(){
        		
				this.loading=true;
				service.post('employer/addEmployerUser', this.employer, {
	                'Authorization': this.userToken,
	                'employerId': this.companyId
	            }).
	            then((res) => {
	            	this.loading=false;
	                this.$message({
	                    type: 'success',
	                    message: 'Employer added successfully.'
	                });
	                this.$router.go(-1);
	                //console.log(res);
	            }).catch((err) => {
	                this.loading=false;
	                this.$message({
	                    type: 'error',
	                    message: 'Sorry, Something Went Wrong: Please try again later.'
	                });
	            }); 
				//console.log('success');
        	},
        	addProfileImg(e) {
                var input = e.target;
                // var img;
                if (input.files && input.files[0]) {
                    var reader = new FileReader();
                    var extension=input.files[0].name.split(".")[input.files[0].name.split(".").length-1];
                    if (input.files[0].size < 30000000 && this.img_format.indexOf(extension) != -1) {
                        reader.onload = (e) => {
                            // img = e.target.result;
                            var type = input.files[0].type.split("/");
                            this.image[0] = {
                                // 'img': img,
                                'name': input.files[0].name,
                                'status': true,
                                'uploading': false,
                                'uploaded': false,
                                'path': '',
                                'type': type[0],
                                'progress': 0,
                                'label': 'Report'
                            };
                        }
                        reader.readAsDataURL(input.files[0]);
                        this.openCropModal();
                        //console.log(this.image);
                        //this.uploadService();
                    } else {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: 'Image size should be less than 30 MB and format should be jpg, jpeg, png and gif'
                        });
                    }
                    //this.onUpdateInputField();

                }
            },
            emailExists(){
                //console.log("Email Status called");
                service.get('user/emailExists', {
                    'Authorization': this.userToken,
                    'email':this.employer.email,
                }).
                then((res) => {
                  //  console.log("Email Status", res.data.result);
                   this.email_status=res.data.result;
                   return res.data.result
                }).catch((err) => {
                    console.log(err);
                });
            },
            uploadService() {
            	this.$validator.validateAll().then((result) => {
        			if(result && this.email_status){
        				if (this.image.length != 0) {
        					this.loading=true;
		                    service.post('attachment/uploadSingleFile', {
	                            'image_file': this.image[0].img,
	                            'file_name': this.image[0].name
	                        }, {
	                            'Authorization': this.userToken,
	                        })
	                        .then((res) => {
	                            //console.log(res);
	                            //resolve(res);
	                            this.image[0].path = res.data.result.path;
	                            this.image[0].uploaded = true;
	                            // console.log('RESPONSONE', res);
	                            this.employer.image=this.image[0].path;
	                            this.addEmployer();
	                        }).catch((err) => {
	                            console.log(err);
	                            this.addEmployer();
	                        });
		                } else {
		                    this.addEmployer();
		                }	
        			}else{
        				this.$notify.error({
                            title: this.$t('error'),
                            message: 'Please fill in all required fields marked with an asterisk.'
                        });	
        			}

        		});
            },
       	},
        mounted() {
        	let self=this;
            $(document).on('change', '.btn-file :file', function() {
                var input = $(this),
                    label = input.val().replace(/\\/g, '/').replace(/.*\//, '');
                input.trigger('fileselect', [label]);
            });

            $('.btn-file :file').on('fileselect', function(event, label) {
                var input = $(this).parents('.input-group').find(':text'),
                    log = label;
                if (input.length) {
                    input.val(log);
                } else {
                    if (log) alert(log);
                }
            });

            function readURL(input) {

                var extension=input.files[0].name.split(".")[input.files[0].name.split(".").length-1];
                if (input.files && input.files[0] && input.files[0].size < 30000000 && self.img_format.indexOf(extension) != -1) {
                    var reader = new FileReader();
                    reader.onload = function(e) {
                        // $('#img-upload').attr('src', '');
                        // console.log(e.target.result);
                        self.cropImg='';
                        self.cropableImg=e.target.result;
                        self.$refs.cropper.replace(e.target.result);

                        var type = input.files[0].type.split("/");
                        self.image[0] = {
                            // 'img': img,
                            'name': input.files[0].name,
                            'status': true,
                            'uploading': false,
                            'uploaded': false,
                            'path': '',
                            'type': type[0],
                            'progress': 0,
                            'label': 'Report'
                        };

                        setTimeout(()=>{
                            self.cropImg = self.$refs.cropper.getCroppedCanvas().toDataURL();
                        },1000)
                    }
                    reader.readAsDataURL(input.files[0]);
                }else {
                    self.$notify.error({
                        title: this.$t('error'),
                        message: 'Image size should be less than 30 MB and format should be jpg, jpeg, png and gif'
                    });
                }
                
                // self.onUpdateInputField();
            }

            $("#imgInp").change(function() {
                readURL(this);
            });
        },
        created() {
            
        }
    }

</script>
<style scoped>
sup {
	color: red;
}

</style>